import { AppButton } from '@/ui/buttons';
import { FlexContainer } from '@/ui/styled-ui';
import React from 'react';
import { useTranslation } from 'react-i18next';
import styled from 'styled-components';

const Banner = styled(FlexContainer)`
  padding: var(--big-padding);
  border-radius: var(--semi-medium-border-radius);
`;

const BannerContent = styled.div`
  display: flex;
  flex-direction: column;
  gap: var(--xsmall-padding);
`;

const BannerHeading = styled.h2`
  font-size: var(--heading-medium-font-size);
  font-weight: 600;
  margin: 0;
`;

const BannerDescription = styled.p`
  font-size: var(--small-font-size);
  margin: 0;
`;

const CheckIcon = styled.i`
  font-size: 2.5rem;
  color: var(--green-dark);
  flex-shrink: 0;
`;

type WhitelistingStatusBannerProps = {
  isCompleted: boolean;
  onStartWhitelisting?: () => void;
  className?: string;
};

export const WhitelistingStatusBanner: React.FC<
  WhitelistingStatusBannerProps
> = ({ isCompleted, onStartWhitelisting, className }) => {
  const { t } = useTranslation();

  if (isCompleted) {
    return (
      <Banner
        justify="space-between"
        align="center"
        className={className}
        style={{ background: 'var(--green-pale)' }}
      >
        <BannerContent>
          <BannerHeading style={{ color: 'var(--green-dark)' }}>
            {t('account.trainingSettings.phishing.whitelistingCompleted')}
          </BannerHeading>
          <BannerDescription style={{ color: 'var(--green-dark)' }}>
            {t('account.trainingSettings.phishing.whitelistingCompletedDesc')}
          </BannerDescription>
        </BannerContent>
        <CheckIcon className="pi pi-check-circle" />
      </Banner>
    );
  }

  return (
    <Banner
      justify="space-between"
      align="center"
      className={className}
      style={{ background: 'var(--red-dark-opacity-light)' }}
    >
      <BannerContent>
        <BannerHeading style={{ color: 'var(--red-dark)' }}>
          {t('account.trainingSettings.phishing.whitelistingNotCompleted')}
        </BannerHeading>
        <BannerDescription style={{ color: 'var(--red-dark)' }}>
          {t('account.trainingSettings.phishing.whitelistingNotCompletedDesc')}
        </BannerDescription>
      </BannerContent>
      <AppButton onClick={onStartWhitelisting} severity="danger">
        {t('phishing.simulations.banner.startWhitelisting')}
      </AppButton>
    </Banner>
  );
};
